module.exports = __webpack_public_path__ + "static/portfolio-mas-13-a603b0af89fb40cfb31c9be8da371d55.jpg";